module.exports = __webpack_public_path__ + "assets/images/rbyearend-10-desktop.jpg?v=2181573e";